import { render, staticRenderFns } from "./BannerItem.vue?vue&type=template&id=52023ac2&scoped=true"
import script from "./BannerItem.vue?vue&type=script&lang=js"
export * from "./BannerItem.vue?vue&type=script&lang=js"
import style0 from "./BannerItem.vue?vue&type=style&index=0&id=52023ac2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52023ac2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52023ac2')) {
      api.createRecord('52023ac2', component.options)
    } else {
      api.reload('52023ac2', component.options)
    }
    module.hot.accept("./BannerItem.vue?vue&type=template&id=52023ac2&scoped=true", function () {
      api.rerender('52023ac2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/skinSetting/components/BannerItem.vue"
export default component.exports